import { Toaster as HotToaster } from 'react-hot-toast'
import type { DefaultToastOptions } from 'react-hot-toast'

interface ToasterProps {
  /**
   * @default 'bottom-left'
   */
  position?: DefaultToastOptions['position']

  /**
   * @default true
   */
  reverseOrder?: boolean
}

function Toaster({ position = 'bottom-left', reverseOrder = true }: ToasterProps) {
  return (
    <HotToaster
      position={position}
      containerStyle={{
        bottom: 24,
        left: 24,
        top: 24,
        right: 24,
      }}
      gutter={6}
      reverseOrder={reverseOrder}
    />
  )
}

export default Toaster
